import { Button, Box } from '@mui/material';
import { memo, useCallback } from 'react';

export type ColorButtonProps = {
  color?: string;
  active?: boolean;
  onColorChange?: (color: string) => void; // eslint-disable-line no-unused-vars
};

export const ColorButton = memo(
  ({ color, active, onColorChange }: ColorButtonProps) => {
    const handleClick = useCallback(() => {
      if (onColorChange) {
        onColorChange(color || '');
      }
    }, [onColorChange, color]);

    return (
      <Button
        onClick={handleClick}
        sx={{
          padding: '6px',
          minWidth: 'unset',
          borderRadius: 1,
          backgroundColor: active ? 'action.hover' : 'transparent',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <Box
          sx={{
            width: 16,
            height: 16,
            borderRadius: '4px',
            backgroundColor: color || 'inherit',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
            border: active ? '1px solid' : 'none',
            borderColor: 'primary.main',
            '&:hover': {
              border: '1px solid',
              borderColor: 'primary.main',
            },
          }}
        />
      </Button>
    );
  }
);

ColorButton.displayName = 'ColorButton';
